// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { HTMLDivProps, Text } from "@blueprintjs/core";

import { Classes, MPDButton } from "src/mpd-library";

import "./styles.css";

export interface IMultiMediaRecordProps extends HTMLDivProps {
  multiMedia: any;
  onRecordAudio?(event: any, type: string): void;
}

export const MultiMediaRecord: React.SFC<IMultiMediaRecordProps> = props => {
  const { multiMedia, onRecordAudio } = props;
  const { voice } = multiMedia;
  const { timer, state } = voice;

  const classes = classNames(
    "multimedia-record",
    state !== null && Classes.ACTIVE
  );

  return (
    <div className={classes}>
      <Text className={classNames("timer", state !== "init" && Classes.ACTIVE)}>
        {timer}
      </Text>
      <MPDButton
        className={classNames(
          "record-button",
          state === "init" && Classes.ACTIVE
        )}
        onClick={(e: any) => onRecordAudio && onRecordAudio(e, "record")}
        name="record-button"
      />
      <MPDButton
        name="stop-button"
        className={classNames(
          "stop-button",
          state === "record" && Classes.ACTIVE
        )}
        onClick={(e: any) => onRecordAudio && onRecordAudio(e, "stop")}
      />
      <MPDButton
        name="pause-button"
        className={classNames(
          "pause-button",
          state === "play" && Classes.ACTIVE
        )}
        onClick={(e: any) => onRecordAudio && onRecordAudio(e, "pause")}
      />
      <MPDButton
        name="play-button"
        className={classNames(
          "play-button",
          (state === "stop" || state === "pause") && Classes.ACTIVE
        )}
        onClick={(e: any) => onRecordAudio && onRecordAudio(e, "play")}
      />
      <Text className="action-text">
        {state === "init" ? (
          "Start Recording"
        ) : state === "record" ? (
          "Stop Recording"
        ) : state === "stop" || state === "pause" ? (
          "Play Recording"
        ) : (
          state === "play" && "Pause Recording"
        )}
      </Text>
      <MPDButton
        className={classNames(
          "delete-audio",
          (state === "stop" || state === "play" || state === "pause") &&
            Classes.ACTIVE
        )}
        text="Delete &amp; try again"
        onClick={(e: any) => onRecordAudio && onRecordAudio(e, "delete")}
      />
      <div
        className={classNames(
          "footer-button",
          (state === "stop" || state === "play" || state === "pause") &&
            Classes.ACTIVE
        )}
      >
        <MPDButton
          text="Save Audio Recording"
          onClick={(e: any) => onRecordAudio && onRecordAudio(e, "save")}
        />
      </div>
      <div />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/multimedia/multimedia-record.tsx